export interface AiChatPageClassNames {
  fullScreen: string;
  pageContent: string;
  conversation: string;
}

export const AI_CHAT_SHORT_VIEWPORT_MAX_HEIGHT = 600;
